<template lang="pug">
.request-detail-modal
  //- b-modal(v-model="_modalShow" size="lg" no-close-on-backdrop no-close-on-esc @ok="onUpdate")
  b-modal(v-model="_modalShow" size="lg" title="" no-close-on-backdrop no-close-on-esc)
    .register-body(v-if="request")
      .resident-info(v-if="request.residentInfo")
        FormLabel(key-name="年齢" :value="request.residentInfo.age")
        FormLabel(key-name="性別" :value="request.residentInfo.gender")
        FormLabel(key-name="介護度" :value="convertCareLevelLabel(request.residentInfo.careLevel)")
        LabelAdl(v-model="request.residentInfo.adl")
        FormLabel(key-name="退所（退院）予定日" :value="convertOutDatetime(request.residentInfo.outDatetime)")
      FormLabel(key-name="メッセージ内容（補足説明等）" :value="request.messageText")

    template(#modal-footer="{ ok, cancel }")
      .buttons
        //- button.btn.modal-ok-btn(type="button" @click="ok()") OK
        button.btn.modal-cancel-btn(type="button" @click="cancel()") 閉じる
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { CareLevel, OtherOfficeAcceptanceRequestsGetModel } from "@/commons/services/OtherOfficeAcceptanceRequests";

import FormLabel from "@/pc/components/forms/FormLabel.vue";
import LabelAdl from "@/pc/components/otherOfficeRoomSchedules/LabelAdl.vue";

/**
 * ### リクエスト詳細モーダル
 */
@Component({
  components: {
    FormLabel,
    LabelAdl
  }
})
export default class RequestDetailModal extends Vue {
  /** モーダル表示可否 */
  @Prop()
  value!: boolean;
  /** 表示対象のリクエスト */
  @Prop()
  request!: OtherOfficeAcceptanceRequestsGetModel;

  get _modalShow(): boolean {
    return this.value;
  }

  set _modalShow(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  convertOutDatetime(outDatetime: number | null): string {
    if (!outDatetime) {
      return "";
    }
    return this.$dateUtil.convertNumberToString(outDatetime, "yyyy/mm/dd");
  }

  convertCareLevelLabel(careLevel: CareLevel | null): string {
    if (!careLevel) {
      return "";
    }
    switch (careLevel) {
      case CareLevel.CARE_LEVEL_1000: {
        return "自立";
      }
      case CareLevel.CARE_LEVEL_1010: {
        return "申請中";
      }
      case CareLevel.CARE_LEVEL_2010: {
        return "要支援１";
      }
      case CareLevel.CARE_LEVEL_2020: {
        return "要支援２";
      }
      case CareLevel.CARE_LEVEL_3010: {
        return "要介護１";
      }
      case CareLevel.CARE_LEVEL_3020: {
        return "要介護２";
      }
      case CareLevel.CARE_LEVEL_3030: {
        return "要介護３";
      }
      case CareLevel.CARE_LEVEL_3040: {
        return "要介護４";
      }
      case CareLevel.CARE_LEVEL_3050: {
        return "要介護５";
      }
      default: {
        return "";
      }
    }
  }
  /**
   * ### 更新ボタン押下処理
   *
   * - メッセージ内容の更新を親コンポーネントに通知する
   * - TODO その場合、テキスト入力欄を用意する必要がある
   * - モーダルを非表示にするか否かは親コンポーネントに移譲する
   */
  // onUpdate(modalEvent: any): void {
  //   modalEvent.preventDefault();
  //   this.$emit("onUpdate");
  //   return;
  // }
}
</script>
